
import { createComponent } from '@vue/composition-api';
import UIIcon from '@sbvr/lbe-ui/UIIcon.vue';
import { TFlashItem } from '../types';

export default createComponent({
  name: 'UIFlash',
  props: {
    message: {
      type: String as () => TFlashItem['message'],
    },
    type: {
      type: String as () => TFlashItem['type'],
      default: 'info',
      validator: value => {
        return value === 'success' || value === 'error' || value === 'info';
      },
    },
    render: {
      type: Function,
      // type: Function as () => TFlashItem['render'],
    },
  },
  components: {
    UIIcon,
  },
  methods: {
    close () {
      this.$emit('close');
    },
  },
  computed: {
    icon () {
      if (this.type === 'success') return 'check';
      if (this.type === 'error') return 'alert-triangle';
      if (this.type === 'info') return 'alert-circle';
      return 'check';
    },
    CustomComponent () {
      if (!this.render) return;
      return {
        render: this.render,
      };
    },
  },
});
